export default class TaskRepeatPeriods {
  static HOUR = "hour";

  static DAY = "day";

  static WEEK = "week";

  static MONTH = "month";

  static YEAR = "year";
}
